var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPt = function SvgIconPt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M0 12c0 5.16 3.257 9.559 7.826 11.254L8.87 12.001 7.826.747C3.256 2.443 0 6.841 0 12.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 12c0-6.627-5.372-12-12-12-1.468 0-2.874.264-4.174.746v22.508c1.3.482 2.706.746 4.174.746 6.628 0 12-5.373 12-12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M7.826 16.174a4.174 4.174 0 1 0 0-8.347 4.174 4.174 0 0 0 0 8.347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M5.478 9.913v2.608a2.348 2.348 0 0 0 4.695 0V9.913z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M7.827 13.304a.784.784 0 0 1-.783-.783v-1.043h1.565v1.043a.784.784 0 0 1-.782.783"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconPt;